export const EnquiryPurposeName = {
  STOCK_LISTING: 'I’m interested in listing my stock',
  STOCK_BUYING: ' I’m interested in buying stock',
  GENERAL: 'General enquiry',
};
